import React from 'react';
import { usePlanningActualState } from '../Context/index';

function SalesTable({ years, categoryItem }) {
  const { checkVisible, getFieldValue, getTotalOfField, getVSData, getVSCategoryTotal } = usePlanningActualState();

  const sales = [
    {
      keyName: 'plannedSales',
      name: 'Planned Sales',
    },
    {
      keyName: 'actualSales',
      name: 'Actual Sales',
    },
    {
      keyName: 'plannedMix',
      name: 'Planned Mix (%)',
    },
    {
      keyName: 'actualMix',
      name: 'Actual Mix (%)',
    },
  ];

  return (
    <>
      {(years ?? []).map((currentYear, yearIndex) => {
        return (
          <table key={yearIndex} className="table custom-table layout-fixed  font-13 mr-3">
            <thead>
              <tr>
                {yearIndex === 0 && <th className="w-200px">{categoryItem?.categoryId?.name}</th>}
                {sales.map((salesItem, i) => {
                  const isVisible = checkVisible(salesItem.keyName);
                  return (
                    isVisible && (
                      <th key={i} className="w-200px">
                        <span>
                          {currentYear}&nbsp;
                          {salesItem.name}
                        </span>
                      </th>
                    )
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {categoryItem?.subcategory &&
                categoryItem.subcategory.map((cat2Ele, iCat) => {
                  return (
                    <tr key={iCat}>
                      {yearIndex === 0 && <td>{cat2Ele?.subcategoryId?.name}</td>}
                      {sales.map((salesItem, i) => {
                        const isVisibleTD = checkVisible(salesItem.keyName);
                        return (
                          isVisibleTD && (
                            <td key={i}>
                              {getFieldValue(salesItem.keyName, yearIndex, currentYear, cat2Ele.subcategoryId._id, categoryItem?.categoryId?._id)}
                            </td>
                          )
                        );
                      })}
                    </tr>
                  );
                })}
            </tbody>
            <tfoot>
              <tr>
                {yearIndex === 0 && (
                  <td>
                    <b>Total</b>
                  </td>
                )}
                {sales.map((salesItem, i) => {
                  const isVisibleTD = checkVisible(salesItem.keyName);
                  return (
                    isVisibleTD && (
                      <td key={i}>
                        <b>{getTotalOfField(salesItem.keyName, yearIndex, currentYear, categoryItem?.categoryId?._id)}</b>
                      </td>
                    )
                  );
                })}
              </tr>
            </tfoot>
          </table>
        );
      })}
      <table className="table custom-table layout-fixed font-13 mr-3">
        <thead>
          <tr>
            {(years ?? []).map((childYear, i) => {
              return (
                i > 0 && (
                  <th key={i} className="w-200px">
                    <span>
                      {years[0]} vs {childYear} (%)
                    </span>
                  </th>
                )
              );
            })}
          </tr>
        </thead>
        <tbody>
          {categoryItem?.subcategory &&
            categoryItem.subcategory.map((cat2Elevs, iCatvs) => {
              return (
                <tr key={iCatvs}>
                  {(years ?? []).map((eleYear, iYear) => {
                    return (
                      iYear > 0 && (
                        <td key={iYear} className="w-200px">
                          <span>{getVSData('vsSalesItem', eleYear, cat2Elevs.subcategoryId._id, categoryItem?.categoryId?._id)}</span>
                        </td>
                      )
                    );
                  })}
                </tr>
              );
            })}
        </tbody>
        <tfoot>
          <tr>
            {(years ?? []).map((eleYear, iYear) => {
              return (
                iYear > 0 && (
                  <td key={iYear} className="w-200px">
                    <b>{getVSCategoryTotal('plannedSales', 'actualSales', eleYear, categoryItem?.categoryId?._id)}</b>
                  </td>
                )
              );
            })}
          </tr>
        </tfoot>
      </table>
    </>
  );
}
export default SalesTable;
